import React from 'react';
import { useInView } from 'react-intersection-observer';

const LazyImage = ({ src, alt, onError, onClick, className, width, height, style }) => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Only load the image once when it comes into view
    threshold: 0.1, // Set the threshold as per your requirement
  });

  return (
    <img
      ref={ref}
      src={inView ? src : ''}
      alt={alt}
      style={{ opacity: inView ? 1 : 0, transition: 'opacity 0.5s', ...style }}
      width={width}
      height={height}
      onClick={onClick}
      onError={onError}
      className={className}
    />
  );
};

export default LazyImage;
